export const EVENT_QUERY_KEYS = {
    offEvtList: () => ['event', 'offEvtList'] as const,
};
